import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Action } from 'hljd'
import Data from './Data'
import Manage from './Manage'
import Store from './store'
@inject('pageStore')
@observer
export default class extends Component {
  constructor(props) {
    super(props)

    this.store = new Store()
  }

  componentDidMount() {
    this.props.onInited(this.store)
  }

  render() {
    const { tab, changeTab } = this.store
    const { pageData = {} } = this.props.pageStore
    const { can_buy_packet } = pageData

    return (
      <div style={{ backgroundColor: '#fff' }}>
        <Action
          active={tab}
          onChange={changeTab}
          options={[
            { title: '推广数据', value: '1' },
            { title: '套包管理', value: '2' }
          ]}
          style={{ paddingLeft: 20 }}
        />

        <div style={{ padding: 20 }}>
          {tab == 1 && <Data />}
          {tab == 2 && <Manage can_buy_packet={can_buy_packet} />}
        </div>
      </div>
    )
  }
}
